import { useState } from "react";
import { HelpCircle } from "react-feather";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { LeftBorderAlertTitle } from "../../../../Constants/Constants";
import { LeftBorderAlertSubTitle } from "../../../../Data/UiKits/Alert";

const LeftBorderAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={LeftBorderAlertTitle} span={LeftBorderAlertSubTitle} />
        <CardBody className="live-dark">
          <Alerts color="light-dark" isOpen={active} className={`light alert-dismissible fade text-dark border-left-wrapper`}>
            <HelpCircle />
            <P>{"You can check in on some of those fields below."}</P>
            <Btn color="transperant" close onClick={() => setActive(false)} />
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};
export default LeftBorderAlert;
